"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const reduxHooks_1 = require("src/hooks/reduxHooks");
const thunk_1 = require("src/stores/exportedStore/auth/thunk");
const selectors_1 = require("src/stores/exportedStore/auth/selectors");
const sharedUtils_1 = require("src/utils/sharedUtils");
const AppRoutes_1 = __importDefault(require("./modules/AppRoutes"));
const ForgetPage_1 = __importDefault(require("./auth/ForgetPage"));
const LoginPage_1 = __importDefault(require("./auth/LoginPage"));
const RegisterPage_1 = __importDefault(require("./auth/RegisterPage"));
const MainRoutes = () => {
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [identify, setIdentify] = (0, react_1.useState)(false);
    const dispatch = (0, reduxHooks_1.useAppDispatch)();
    const me = (0, reduxHooks_1.useAppSelector)(selectors_1.selectUser);
    const getMe = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        yield dispatch((0, thunk_1.getCombinedMeThunk)());
        setLoading(false);
    });
    (0, react_1.useEffect)(() => {
        getMe();
    }, []);
    (0, react_1.useEffect)(() => {
        if ((me === null || me === void 0 ? void 0 : me.id) && !identify && !(0, sharedUtils_1.isDev)() && typeof window["adopty"] !== "undefined") {
            console.log("[MainRoutes] identify user");
            setIdentify(true);
            window["adopty"].identify({
                USER_ID: me.id,
                USER_HASH: me.adopty_auth_hash,
                EMAIL: me.email,
                FIRSTNAME: me.first_name,
                LASTNAME: me.last_name,
            });
        }
    }, [me]);
    if (loading) {
        return null;
    }
    if (!(me === null || me === void 0 ? void 0 : me.user_role)) {
        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "main-page" }, { children: (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "d-flex align-items-center justify-content-center main-section w-100" }, { children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Routes, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/", element: (0, jsx_runtime_1.jsx)(LoginPage_1.default, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/register", element: (0, jsx_runtime_1.jsx)(RegisterPage_1.default, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/forget", element: (0, jsx_runtime_1.jsx)(ForgetPage_1.default, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/*", element: (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: "/", replace: true }) })] }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "d-flex main-section main-section__banner w-100" }, { children: (0, jsx_runtime_1.jsx)("div", { className: "d-flex flex-column main-section__banner__content" }) }))] }) })));
    }
    return ((0, jsx_runtime_1.jsxs)(react_router_dom_1.Routes, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/", element: (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: "/clients", replace: true }) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/*", element: (0, jsx_runtime_1.jsx)(AppRoutes_1.default, {}) })] }));
};
exports.default = MainRoutes;
